export default "__VITE_ASSET__935028ef__"